module.exports = __webpack_public_path__ + "images/12dfa53d377b4cef91e2014586165c0b.png";